const EMAIL_PROVIDER_URL_BY_DOMAIN = {
  'mail.ru': 'https://e.mail.ru/',
  'bk.ru': 'https://e.mail.ru/',
  'list.ru': 'https://e.mail.ru/',
  'inbox.ru': 'https://e.mail.ru/',
  'yandex.ru': 'https://mail.yandex.ru/',
  'ya.ru': 'https://mail.yandex.ru/',
  'yandex.ua': 'https://mail.yandex.ua/',
  'yandex.by': 'https://mail.yandex.by/',
  'yandex.kz': 'https://mail.yandex.kz/',
  'yandex.com': 'https://mail.yandex.com/',
  'gmail.com': 'https://mail.google.com/',
  'googlemail.com': 'https://mail.google.com/',
  'outlook.com': 'https://mail.live.com/',
  'hotmail.com': 'https://mail.live.com/',
  'live.ru': 'https://mail.live.com/',
  'live.com': 'https://mail.live.com/',
  'me.com': 'https://www.icloud.com/',
  'icloud.com': 'https://www.icloud.com/',
  'rambler.ru': 'https://mail.rambler.ru/',
  'yahoo.com': 'https://mail.yahoo.com/',
  'inbox.lv': 'https://www.inbox.lv/',
};

export default function (email = '') {
  const index = email.lastIndexOf('@');

  if (index === -1) {
    return;
  }

  const domain = email.slice(index + 1);

  return EMAIL_PROVIDER_URL_BY_DOMAIN[domain];
}
